/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ key: NonNullable<unknown> }} Tl_Dates_ClearedInputs */

const en_tl_dates_cleared = /** @type {(inputs: Tl_Dates_ClearedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dates of ${i?.key} cleared`)
};

const de_tl_dates_cleared = /** @type {(inputs: Tl_Dates_ClearedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Termine von ${i?.key} entfernt`)
};

/**
* | output |
* | --- |
* | "Dates of {key} cleared" |
*
* @param {Tl_Dates_ClearedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tl_dates_cleared = /** @type {((inputs: Tl_Dates_ClearedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tl_Dates_ClearedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_tl_dates_cleared(inputs)
	return en_tl_dates_cleared(inputs)
});